import axios from "axios";
import { useCallback } from "react";
import { REACT_APP_ACR_API_BASE_URL, REACT_APP_ACR_API_PROTOCOL } from "../utlities/core.constants";

export default function usePrimaryPoc() {
  const submitPrimaryPoc = useCallback(async (primaryPoc) => {
    const response = axios.post(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/primaryPoc`, primaryPoc);

    return response;
  }, []);

  const updatePrimaryPoc = useCallback(async (primaryPocId, primaryPoc) => {
    const response = await axios.patch(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/primaryPoc/${primaryPocId}`, primaryPoc);
    return response;
  }, []);

  const getPrimaryPoc = useCallback(async (primaryPocId) => {
    try {
      const response = axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/primaryPoc?id=${primaryPocId}`);

      return (await response).data;
    } catch (e) {
      return {};
    }

  }, []);

  return { submitPrimaryPoc, getPrimaryPoc, updatePrimaryPoc }
}
